import React from "react";
import { Card, Button } from "antd";
import { Avatar } from "antd";
import { LucideAward } from "lucide-react";


const CertificateCard = ({ title, issuedDate, expirationDate }) => 
  {
  
  return (

    <Card className="rounded-2xl bg-green-50 border border-green-500 shadow-sm">
      <div className="flex w-full">
        <div className="top-3 pt-1 pe-3">
            <div className="p-2 rounded-full bg-emerald-100 dark:bg-emerald-900/50">
                <LucideAward className="text-green-600" size={20}/>
            </div>
        </div>
        <div className="w-full">
          <h3 className="text-base font-semibold text-gray-900">
            {title}
          </h3>


          <div className="flex items-center text-gray-700 text-sm mt-1">
            Issued:{issuedDate}
          </div>
          <div className="flex items-center text-gray-700 text-sm">
            Expires: {expirationDate}
          </div>
        <Button
          block
          type="default"
          className="w-full mt-2 rounded-xl bg-white text-gray-800 hover:bg-gray-50 border border-green-400"
        >
          Download Certificate
        </Button>
        </div>

      </div>


    </Card>
  );
};

export default CertificateCard;
